// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__mmotj","content":"Header_content__3Vd28","dark":"Header_dark__3IupP"};